import { render, staticRenderFns } from "./ShowVideo.vue?vue&type=template&id=96c48984&scoped=true&"
import script from "./ShowVideo.vue?vue&type=script&lang=js&"
export * from "./ShowVideo.vue?vue&type=script&lang=js&"
import style0 from "./ShowVideo.vue?vue&type=style&index=0&id=96c48984&lang=scss&scoped=true&"
import style1 from "./ShowVideo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c48984",
  null
  
)

export default component.exports